/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from '@insticator/insticator-ui';



/* ++++++++++ --------------- STACKABLE CHART : STYLES --------------- ++++++++++ */
export default {
    stackablechart: {
        height: pxToEm(80), // make sure parent container have a defined height when using responsive component,
        width: '100%',
        // maxWidth: pxToEm(1000),
        position: 'relative',
        marginTop: pxToEm(53),
        '& > div': {
            height: 'calc(100% + 4px) !important'
        },
        '& text':{
            fill: 'rgba(6, 43, 117, 0.5) !important',
            fontSize: `${pxToEm(11)} !important`
        },
        '&:last-child': {
            height: pxToEm(110)
        }
    }
};
